module.exports = __webpack_public_path__ + "img/ranurte-unsplash-300.52c90f2b.jpg";